// @ts-check

import { useEffect, useState } from "react";

/**
 * Hook initially taken from https://usehooks.com/useLocalStorage
 * Note that we do not handle the error case of writing to local storage.
 * Happily it should fail in the right way if we are careful about what the default flags are.
 * @param {string} key
 * @param {any} initialValue
 * @returns {[any, (value: any) => void]}
 */
function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }

    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue

      console.error(error);
      return initialValue;
    }
  });

  // save state changes to local storage, this means the returned setter is STABLE
  useEffect(() => {
    if (typeof window !== "undefined") {
      try {
        window.localStorage.setItem(key, JSON.stringify(storedValue));
      } catch (error) {
        console.error(error);
      }
    }
  }, [key, storedValue]);

  // return local storage state, and setter that is GUARANTEED STABLE
  return [storedValue, setStoredValue];
}

export default useLocalStorage;
